import React from "react";
import { useSettingsQuery } from "@/api/queries/admin/SettingsQueries";
import { cn } from "@/lib/utils";

type Props = {
  className?: string;
  alt?: string;
};

const SidebarLogo: React.FC<Props> = ({ className, alt = "Logo" }) => {
  const { data } = useSettingsQuery(true);
  const branding = (data as any)?.branding_settings;

  // Get the sidebar logo URL and size
  const sidebarLogoUrl = branding?.sidebar_logo_url;
  const sidebarLogoSize = branding?.sidebar_logo_size ?? 40;

  // Create style object with max height based on size setting
  const logoStyle = {
    maxHeight: `${sidebarLogoSize}px`,
  };

  // If no sidebar logo is set, use the default logo-1.png
  if (!sidebarLogoUrl) {
    return <img src="/assets/logo-1.png" className={cn("h-auto object-contain object-left", className)} style={logoStyle} alt={alt} />;
  }

  return <img src={sidebarLogoUrl} className={cn("h-auto object-contain object-left", className)} style={logoStyle} alt={alt} />;
};

export default SidebarLogo;
